import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPixelEvent } from '../../utils/metaPixel';

// useMetaPixel() already fires the initial PageView on app mount,
// so this only tracks subsequent in-app navigations (no full reload).
export default function MetaPixelRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPixelEvent('PageView');
  }, [location.pathname]);

  return null;
}
